import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Message, Spin } from '@arco-design/web-react';
import { consumeFeishuTicket } from '@/services/auth';
import { setAuthMarkerCookie } from '@/utils/authSession';
import { resolveLandingPath } from '@/routes';
import styles from './style.module.less';

/** StrictMode 下整页只兑换一次 */
let consumeInflight: Promise<Awaited<ReturnType<typeof consumeFeishuTicket>>> | null = null;

function consumeOnce() {
  if (!consumeInflight) {
    consumeInflight = consumeFeishuTicket().finally(() => {
      consumeInflight = null;
    });
  }
  return consumeInflight;
}

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [message, setMessage] = useState(() => t('auth.callback.processing'));

  useEffect(() => {
    let cancelled = false;

    // eslint-disable-next-line no-console
    console.log('[FeishuAuth] frontend /auth/callback (ticket via HttpOnly cookie)');

    async function hydrate() {
      try {
        // eslint-disable-next-line no-console
        console.log('[FeishuAuth] frontend consume start');
        const user = await consumeOnce();
        // eslint-disable-next-line no-console
        console.log('[FeishuAuth] frontend consume success', {
          id: user.id,
          roles: user.roles,
          permissions: user.permissions,
        });
        if (cancelled) {
          return;
        }

        dispatch({ type: 'update-user', payload: { user, userLoading: false } });
        setAuthMarkerCookie();
        dispatch({ type: 'set-hydrated', payload: true });
        Message.success(t('auth.callback.success'));
        navigate(resolveLandingPath(user.permissions ?? []), { replace: true });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[FeishuAuth] frontend consume failed', err);
        if (cancelled) {
          return;
        }
        setMessage(t('auth.callback.failed'));
        dispatch({ type: 'set-hydrated', payload: true });
        Message.error(t('auth.callback.error'));
        navigate('/login?error=oauth_failed', { replace: true });
      }
    }

    void hydrate();

    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate, t]);

  return (
    <div className={styles.container}>
      <Spin size={32} />
      <p className={styles.message}>{message}</p>
    </div>
  );
}
